module.exports = __webpack_public_path__ + "assets/img/modal-avatar-92ec5378.png";